<template>
        <div id="news-detail-view">
            <transition name="fade" mode="out-in" @enter="attachNiceScroll()" @leave="removeNiceScroll()">
                <div v-if="pictureDetail === null" key="news-detail">
                    <transition name="fade" mode="out-in" @enter="detailChangeEnter()" @leave="detailChangeLeave()">
                        <div class="item" :key="currentItem.id">
                            <span class="close" @click="back()">&times;</span>
                            <span class="date">{{ currentItem.date }}</span>
                            <h3>{{ currentItem.title }}</h3>
                            <pictures-viewer :pictures-list="currentItem._images"
                                             :first-image-idx.sync="currentImage"
                                             @show="showPicture"
                            ></pictures-viewer>
                            <span class="text" ref="description">
                                <p>{{ currentItem.short_description }}</p>
                                <p v-html="currentItem.full_description"></p>
                            </span>
                        </div>
                    </transition>
                    <div class="pagination">
                        <span class="arrow arrow-left" v-show="hasPrev" @click="prev"></span>
                        <span class="back" @click="back()">Powrót</span>
                        <span class="arrow arrow-right" v-show="hasNext" @click="next"></span>
                    </div>
                </div>
                <picture-detail v-else=""
                                key="picture-detail"
                                :_picture-detail="pictureDetail"
                                :pictures-list="currentItem._images"
                                @reset="resetPicture"
                ></picture-detail>
            </transition>
        </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
    #news-detail-view {
        position: relative;
        padding-bottom: 56px;
        height: 530px;
        .item {
            padding: 0 50px;
            text-align: left;
            height: 470px;
            display: flex;
            flex-direction: column;

            .date {
                display: block;
                font-size: 12px;
                font-style: italic;
            }

            h3 {
                opacity: 1;
                margin: 5px 0 10px;
            }

            #pictures-viewer {
                // Cannot merge to single margin attribute because it would override internal component css
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .text {
                display: block;
                text-align: justify;
                padding-right: 10px;  // For nicescroll
                overflow: hidden;

                p {
                    white-space: pre-wrap;
                }
            }
        }

        .close {
            position: absolute;
            right: 0;

            font-size: 21px;
            font-weight: normal;
            color: white;
            opacity: 0.5;

            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }
        }
    }
</style>

<script>
    import PicturesViewer from './PicturesViewer.vue';
    import PictureDetail from './PictureDetail.vue';

    export default {
        name: 'LoginNewsDetail',
        components: {
            PicturesViewer,
            PictureDetail,
        },
        props: {
            _currentItem: {
                type: Object,
                required: true,
            },
            newsList: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                currentIdx: this.newsList.findIndex(item => item.id === this._currentItem.id),
                currentItem: this._currentItem,
                pictureDetail: null,
                currentImage: 0,
            };
        },
        mounted() {
            this.attachNiceScroll();
            window.addEventListener('keyup', this.backOnEscape);
        },
        beforeDestroy() {
            this.removeNiceScroll();
            window.removeEventListener('keyup', this.backOnEscape);
        },
        computed: {
            hasNext() {
                return this.currentIdx < this.newsList.length - 1;
            },
            hasPrev() {
                return this.currentIdx > 0;
            },
        },
        methods: {
            detailChangeEnter() {
                this.attachNiceScroll();
                this.currentImage = 0;
            },
            detailChangeLeave() {
                this.removeNiceScroll();
            },
            removeNiceScroll() {
                $(this.$refs.description).getNiceScroll().remove();
            },
            attachNiceScroll() {
                $(this.$refs.description).niceScroll({
                    background: 'rgba(255, 255, 255, 0.1)',
                    cursorcolor: 'rgba(255, 255, 255, 0.50)',
                    cursorborder: 'rgba(255, 255, 255, 0.50)',
                    autohidemode: false,
                }).resize();
            },
            backOnEscape(event) {
                if (event.keyCode === 27) {
                    event.stopPropagation();
                    if (this.pictureDetail !== null) {
                        // If we're in picture view just go back to detail view
                        this.pictureDetail = null;
                    } else {
                        this.back();
                    }
                }
            },
            back() {
                this.$emit('reset');
            },
            next() {
                if (this.hasNext) {
                    this.currentIdx += 1;
                    this.currentItem = this.newsList[this.currentIdx];
                }
            },
            prev() {
                if (this.hasPrev) {
                    this.currentIdx -= 1;
                    this.currentItem = this.newsList[this.currentIdx];
                }
            },
            showPicture(index) {
                this.pictureDetail = index;
            },
            resetPicture() {
                this.pictureDetail = null;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// LoginNewsDetail.vue?c17aa0d4